export default {
  optional: "optional",
  requiredErrorMessage: label => `Enter ${label}`
};